import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((_colors, rt) => ({
  content: {
    paddingBottom: rt.insets.bottom + theme.spacing[5],
    paddingHorizontal: theme.spacing[5],
    variants: {
      consentType: {
        adultOnly: {
          _web: {
            maxHeight: rt.screen.height * 0.6,
          },
        },
        notification: {},
      },
    },
  },
  pageContainer: {
    width: '100%',
  },
}));
